import angular from 'angular';

import newRelicServiceModule from './NewRelicService';
import logServiceModule from './LogService';
import internalAnalyticsPublishingService from './InternalAnalyticsPublishingService';
import { uuidv4 } from "../util";

export class AnalyticsService {
  constructor(
    $window,
    $q,
    LogService,
    NewRelicService,
    InternalAnalyticsPublishingService
  ) {
    this.$window = $window;
    this.$q = $q;
    this.LogService = LogService;
    this.NewRelicService = NewRelicService;
    this.InternalAnalyticsPublishingService = InternalAnalyticsPublishingService;
    this._eventTimers = {};
  }

  trackEvent(eventName, ...args) {
    const data = args.length > 0 ? args[0] : null;
    try {
      this.NewRelicService.addPageAction(eventName, ...args);
    } catch (e) {
      this.LogService.warn("Error calling NewRelicService.addPageAction():", e);
    }
    try {
      this.InternalAnalyticsPublishingService.trackEvent(eventName, data);
    } catch (e) {
      this.LogService.warn(`AnalyticsService.trackEvent(${eventName}) error calling InternalAnalyticsPublishingService:`, e);
    }
  }

  setCustomAttribute(name, value) {
    try {
      this.NewRelicService.setCustomAttribute(name, value);
    } catch (e) {
      this.LogService.warn("Error calling NewRelicService.setCustomAttribute():", e);
    }
    try {
      this.InternalAnalyticsPublishingService.setCustomAttribute(name, value);
    } catch (e) {
      this.LogService.warn(`AnalyticsService.setCustomAttribute(${name}, ...) error calling InternalAnalyticsPublishingService:`, e);
    }
  }

  startEventTimer(eventName) {
    const start = new Date();
    this._eventTimers[eventName] = start;
    return start;
  }

  stopTimer(eventName) {
    if (eventName in this._eventTimers) {
      const start = this._eventTimers[eventName];
      const end = new Date();
      const duration = end - start;
      return {
        start,
        end,
        duration,
      };
    } else {
      this.LogService.warn(`AnalyticsService.stopTimer() called with non-existent event name:`, eventName);
      return null;
    }
  }

  stopTimerAndTrackEvent(eventName, data) {
    const timerInfo = this.stopTimer(eventName);
    if (timerInfo) {
      const { duration} = timerInfo;
      return this.trackEvent(eventName, {
        ...data,
        duration,
      })
    } else {
      this.LogService.warn(`AnalyticsService.stopTimerAndTrackEvent() called with non-existent event name:`, eventName);
      return this.trackEvent(eventName, ...args);
    }
  }
}

export const moduleName = 'recaps.services.AnalyticsService';
export let module = angular.module(moduleName, [
  newRelicServiceModule.name,
  logServiceModule.name,
  internalAnalyticsPublishingService.name,
]);
module.service('AnalyticsService', AnalyticsService);
export default module;
